import { Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { RootState } from '../store';
import Logo from './Logo';
import MainNavigation from './MainNavigation';
import Painting from './Painting';
import VirtualHelp from './VirtualHelp';
import VirtualInfo from './VirtualInfo';
import { initLayoutState1, LayoutMaxWidth, MediaQueryFixMargin, MediaQueryMobile, MediaQueryScaleMargin, MediaQueryShallow, MediaQuerySmall1, MediaQuerySmall2, MediaQuerySmall3, MediaQuerySmall4, MediaQuerySmall5 } from '../Layout';

export default function SiteVirtualTour(params: {nav: string}) {
    return (
        <>
            {params.nav === "virtualtour" &&
                <div>
                    <Painting name="Zirkus4" hidden={true} fromTour={true}></Painting>
                    <Painting name="Zirkus2" hidden={true} fromTour={true}></Painting>
                    <Painting name="Papagena" hidden={true} fromTour={true}></Painting>
                    <Painting name="Hamlet" hidden={true} fromTour={true}></Painting>
                    <VirtualHelp></VirtualHelp>
                    <VirtualInfo></VirtualInfo>
                </div>
            }
        </>
    );
}